/**
 * Phase 14 — Mockup: MissionDetail-Panel mit aktiven Maßnahmen.
 * Eine grüne (erfüllt) und eine rote (fehlt) Maßnahme.
 */
export function MissionDetailMockup() {
  return (
    <svg
      viewBox="0 0 800 500"
      className="h-auto w-full rounded-xl"
      role="img"
      aria-label="Mission-Detail mit Maßnahmen-Liste"
    >
      <rect width="800" height="500" fill="#0a0e1a" />

      {/* Panel Frame */}
      <rect
        x="30"
        y="30"
        width="320"
        height="440"
        rx="12"
        fill="#11151f"
        stroke="#1f2937"
      />

      {/* Header */}
      <text x="50" y="70" fill="#ffffff" fontFamily="Inter, sans-serif" fontSize="20" fontWeight="700">
        Wohnungsbrand
      </text>
      <text x="50" y="92" fill="#9ca3af" fontFamily="Inter, sans-serif" fontSize="12">
        F2 · Ebertstraße 17 · seit 02:14
      </text>

      {/* Status row */}
      <rect x="50" y="110" width="80" height="24" rx="12" fill="#dc2626" />
      <text x="90" y="127" fill="#ffffff" fontSize="11" textAnchor="middle" fontWeight="600">
        STATUS 4
      </text>
      <rect x="138" y="110" width="78" height="24" rx="12" fill="#1f2937" />
      <text x="177" y="127" fill="#9ca3af" fontSize="11" textAnchor="middle" fontWeight="600">
        AM ORT
      </text>

      {/* Section heading */}
      <text x="50" y="170" fill="#9ca3af" fontFamily="Inter, sans-serif" fontSize="11" fontWeight="600" letterSpacing="1.5">
        MASSNAHMEN
      </text>

      {/* Measure 1 — done */}
      <rect x="50" y="180" width="280" height="56" rx="8" fill="#052e1a" stroke="#15803d" />
      <circle cx="68" cy="208" r="9" fill="#22c55e" />
      <text x="68" y="212" fill="#ffffff" fontSize="11" textAnchor="middle" fontWeight="700">✓</text>
      <text x="86" y="206" fill="#ffffff" fontSize="13" fontWeight="600">Brandbekämpfung</text>
      <text x="86" y="222" fill="#86efac" fontSize="10">2 × HLF · Wassertank ausreichend</text>

      {/* Measure 2 — blocked */}
      <rect x="50" y="246" width="280" height="56" rx="8" fill="#3b0a0a" stroke="#b91c1c" />
      <circle cx="68" cy="274" r="9" fill="#ef4444" />
      <text x="68" y="278" fill="#ffffff" fontSize="11" textAnchor="middle" fontWeight="700">✗</text>
      <text x="86" y="272" fill="#ffffff" fontSize="13" fontWeight="600">Atemschutz</text>
      <text x="86" y="288" fill="#fca5a5" fontSize="10">benötigt: 4 PA · vorhanden: 2</text>

      {/* Progress bar */}
      <text x="50" y="334" fill="#9ca3af" fontSize="11" fontWeight="600">FORTSCHRITT</text>
      <rect x="50" y="342" width="280" height="6" rx="3" fill="#1f2937" />
      <rect x="50" y="342" width="120" height="6" rx="3" fill="#dc2626" />
      <text x="50" y="368" fill="#fca5a5" fontSize="10">blockiert — Atemschutz-Anforderung offen</text>

      {/* Map area on right */}
      <rect x="380" y="30" width="390" height="440" rx="12" fill="#0b1426" />
      <g stroke="#1f2937" strokeWidth="1">
        {Array.from({ length: 8 }).map((_, i) => (
          <line key={`v${i}`} x1={380 + i * 50} y1={30} x2={380 + i * 50 + 16} y2={470} />
        ))}
        {Array.from({ length: 9 }).map((_, i) => (
          <line key={`h${i}`} x1={380} y1={30 + i * 50} x2={770} y2={30 + i * 50 - 8} />
        ))}
      </g>
      {/* Mission marker */}
      <circle cx="565" cy="220" r="22" fill="#dc2626" opacity="0.3">
        <animate attributeName="r" values="14;30;14" dur="2.2s" repeatCount="indefinite" />
      </circle>
      <circle cx="565" cy="220" r="8" fill="#dc2626" stroke="#ffffff" strokeWidth="1.5" />

      {/* Vehicle markers */}
      <circle cx="500" cy="270" r="6" fill="#ffffff" stroke="#dc2626" strokeWidth="2" />
      <circle cx="610" cy="180" r="6" fill="#ffffff" stroke="#dc2626" strokeWidth="2" />
    </svg>
  );
}
